<template lang="html">
    <div class="previewBSQR-page">
        <Slogan theTitle="被申请人"/>
        <template v-if="bsqr && bsqr.length">
            <van-cell-group class="bsqr-box" v-for="(item, index) in this.bsqr"
                            :key="index">
                <van-field
                    v-model="item.cDsrlx"
                    readonly
                    label="被申请人类型"
                ></van-field>
                <van-field
                    v-if="item.cDsrlx1 == 1"
                    v-model="item.cDsrxm"
                    clearable
                    readonly
                    label="姓名"
                ></van-field>
                <van-field
                    v-if="item.cDsrlx1 == 1"
                    v-model="item.cDsrxb"
                    clearable
                    readonly
                    label="性别"
                ></van-field>
                <van-field
                    v-if="item.cDsrlx1 == 1"
                    v-model="item.nMz"
                    clearable
                    readonly
                    label="民族"
                ></van-field>
                <van-field
                    v-if="item.cDsrlx1 == 1"
                    v-model="item.nNl"
                    clearable
                    readonly
                    label="年龄"
                ></van-field>
                <van-field
                    v-if="item.cDsrlx1 == 1"
                    v-model="item.dtDsrbirthday"
                    readonly
                    clickable
                    label="出生日期"
                ></van-field>
                <van-field
                    v-if="item.cDsrlx1 == 1"
                    v-model="item.cZjlx"
                    readonly
                    label="证件类型"
                    class="amount-ipt"
                    @click="toastJointCcxx(item.cZjlx)"
                ></van-field>
                <van-field
                    v-if="item.cDsrlx1 == 1"
                    v-model="item.cZjh"
                    readonly
                    label="证件号码"
                    @click="toastJointCcxx(item.cZjh)"
                ></van-field>
                <van-field
                    v-if="item.cDsrlx1 != 1"
                    v-model="item.cQymc"
                    clearable
                    readonly
                    label="单位名称"
                    @click="toastJointCcxx(item.cQymc)"
                ></van-field>



                <!--            <van-field
                                    v-if="item.cDsrlx1 != 1"
                                    v-model="item.cZzjgdm"
                                    class="special-xydm"
                                    readonly
                                    clickable
                                    label="统一社会信用代码"
                                    @click="toastJointCcxx(item.cZzjgdm)"
                            ></van-field>-->
                <van-field
                    v-if="item.cDsrlx1 != 1"
                    v-model="item.nZzlxText"
                    clearable
                    readonly
                    class="special-xydm"
                    label="证照类型"
                    @click="toastJointCcxx(item.nZzlxText)"
                ></van-field>
                <van-field
                    v-if="item.cDsrlx1 != 1"
                    v-model="item.cZzjgdm"
                    clearable
                    readonly
                    class="special-xydm"
                    label="证照号码"
                    @click="toastJointCcxx(item.cZzjgdm)"
                ></van-field>

                <van-field
                    v-if="item.cDsrlx1 != 1"
                    v-model="item.cDwxz"
                    readonly
                    clickable
                    label="单位性质"
                ></van-field>

                <van-field
                    v-if="item.cDsrlx1 != 1"
                    v-model="item.cQyfr"
                    readonly
                    label="法定代表人"
                ></van-field>
                <van-field
                    v-model="item.cPhoneno"
                    label="手机号码"
                    readonly
                    class="amount-ipt"
                ></van-field>
                <van-field
                    v-model="item.cGddh"
                    class="amount-ipt"
                    readonly
                    label="固定电话"
                ></van-field>
                <van-field
                    v-if="item.cDsrlx1 == 1"
                    v-model="item.cTxdz"
                    readonly
                    label="经常居住地"
                    @click="toastJointCcxx(item.cTxdz)"
                ></van-field>
                <van-field
                    v-if="item.cDsrlx1 != 1"
                    v-model="item.cTxdz"
                    readonly
                    label="单位地址"
                    @click="toastJointCcxx(item.cTxdz)"
                ></van-field>
            </van-cell-group>
        </template>
<!--        暂无数据的提示 -->
        <p v-else class="fd-empty-tips">暂无数据</p>
    </div>
</template>

<script>
    import Slogan from '../../../components/common/slogan'
    import { Toast } from 'vant';
    import {typeXb, typeRylx, typeSfzjlx, typeSqr, typeGzdwlx, typeMz, typeZzlx} from '../../../filters/index'

    export default {
        components: {
            Slogan
        },
        data() {
            return {
                bsqr: [],
                sex: "",
                mz: "",
                bSqrlx: "",
                bSqrlx2: "",
                bSqrlx3: "",
                dwxz1: "",
                dwxz2: "",
                zjlx: ""
            }
        },
        methods: {
              toastJointCcxx(value){
                Toast(value);
            },
            getBsqrList() {
                let Id = window.sessionStorage.getItem("dbid")
                this.$axios.get('ssbq/api/ssdb/bsqrsxq' + "?time=" + new Date().getTime() + "&dbid=" + Id).then(res => {
                    // this.bsqr = res.data
                    window.sessionStorage.setItem("ccsyrDB",JSON.stringify(res.data))
                    //代码值特殊处理
                    res.data && res.data.map((item, index) => {
                        // if(item.cGh == '--'){
                        //     item.cGh = ''
                        // }
                        // if(item.cDsrlx == 1){
                        //     this.bSqrlx = typeRylx(item.cDsrlx)
                        // }else if(item.cDsrlx == 2){
                        //     this.bSqrlx2 = typeRylx(item.cDsrlx)
                        //     this.dwxz1 = typeGzdwlx(item.cDwxz)
                        // }else if(item.cDsrlx == 3){
                        //     this.bSqrlx3 = typeRylx(item.cDsrlx)
                        //     this.dwxz2 = typeGzdwlx(item.cDwxz)
                        // }
                        // this.sex = typeXb(item.cDsrxb)
                        // this.mz = typeMz(item.nMz)
                        // this.zjlx = typeSfzjlx(item.cZjlx)
                        let temp = {
                            cBqDsrid:item.cBqDsrid,
                            cBqId:item.cBqId,
                            cDsrlx:typeRylx(item.cDsrlx),
                            cDsrlx1:item.cDsrlx,
                            cDsrxb:typeXb(item.cDsrxb),
                            cDsrxm:item.cDsrxm,
                            cDwxz:typeGzdwlx(item.cDwxz),
                            cGddh:item.cGddh,
                            cPhoneno:item.cPhoneno,
                            cQyfr:item.cQyfr,
                            cQymc:item.cQymc,
                            cQyzcdjh:item.cQyzcdjh,
                            cTxdz:item.cTxdz,
                            cZjh:item.cZjh,
                            cZjlx:typeSfzjlx(item.cZjlx),
                            nZzlxText:typeZzlx(item.nZzlx),
                            cZzjgdm:item.cZzjgdm,
                            dtDsrbirthday:item.dtDsrbirthday,
                            nMz:typeMz(item.nMz),
                            nNl:item.nNl
                        }
                        this.bsqr.push(temp)
                    })
                })

            }
        },
        created() {
            this.getBsqrList()
        }
    }
</script>
